import React from 'react';
import '../styles/Footer.css';
import { FaPhoneAlt, FaEnvelope } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="footer-section">
      <div className="footer-overlay">

        <div className="footer-column">
          <h4>COMPANY</h4>
          <ul>
            <li><a href="/aboutus">About Us</a></li>
            <li><a href="/servicepg">Our Services</a></li>
            <li><a href="/contactpg">Careers</a></li>
            <li><a href="/contactpg">Contact Us</a></li>
          </ul>
        </div>

        <div className="footer-column">
          <h4>QUICK LINKS</h4>
          <ul>
             <li><a href="/mechpg">Mechanical</a></li>
            <li><a href="/civilpg">Civil</a></li>
          </ul>
        </div>

        <div className="footer-column">
          <h4>SERVICES</h4>
          <ul>
            
            <li><a href="/services/service1">Engineering Design</a></li>
            <li><a href="/services/service2">Testing And Commissioning</a></li>
            {/* <li><a href="/services/service3">Equipment Rental</a></li>
            <li><a href="/services/service4">Skilled Manpower</a></li>
            <li><a href="/services/service5">Transformer Oil Filtration</a></li>    */}
          </ul>
        </div>

        <div className="footer-column">
          <h4>CONTACT</h4>
          <ul>
            <li>
              <FaPhoneAlt className="footer-icon" />
              <a href="tel:+91 8925288802"> +91 8925288802</a>
            </li>
            <li>
              <FaEnvelope className="footer-icon" />
              <a href="mailto:services@apexcel.in">hr@apexcel.in</a>
            </li>
          </ul>
        </div>

      </div>
    </footer>
  );
};

export default Footer;
